import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { ThemeOptions } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string
    }
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string
    }
  }
}

const themeOptions: ThemeOptions = {
  typography: {
    // fontSize: 16, // Default browser font size
    fontFamily: 'Roboto',
    h1: {
      fontSize: '3rem',
      fontWeight: '700' as any,
      color: '#303133',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: '600' as any,
      color: '#303133',
      marginBottom: '1rem',
    },
    h3: {
      fontSize: '2.0rem',
      fontWeight: '600' as any,
      color: '#303133',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: '600' as any,
      color: '#303133',
    },
    button: {
      fontSize: '1rem',
      fontWeight: '600' as any,
    },
    body2: {
      color: '#303133',
      textAlign: 'left',
      fontFamily: 'Lora',
      flex: 1,
      fontWeight: 500,
      marginTop: 0,
      marginBottom: 15,
      fontSize: '1.125rem',
      lineHeight: '1.75',
    },
  },
  palette: {
    // mode: 'light',
    primary: {
      main: '#f271b8',
    },
    // secondary: {
    //   main: '#d9559d',
    //   contrastText: '#fff',
    // },
  },
}

export default responsiveFontSizes(createTheme(themeOptions), { factor: 2 })
